<template>
    <div class="recipientWrap" @keydown="doRecipientKey" tabindex="0" ref="wrap"
            :class="{tagActive: selectedRecipient!==-1, border}">
        <div class="label" v-if="label"><label>{{label}}</label></div>
        <div class="entries">
            <span class="tag" v-for="(r, ind) in value" :key="ind"
                    :class="{selected: ind===selectedRecipient, errored: isErrored(r)}"
                    :aria-selected="ind===selectedRecipient" ref="rcpt">{{r}}
                <font-awesome-icon :icon="['fal', 'times']" size="sm" class="deleter"
                        @click="doDelete(ind)"></font-awesome-icon>
            </span>
            <input type="email" class="input" v-model="inputValue" ref="input" @keydown.stop="doInputKey"
                    :class="{ valid: isValid, empty: !inputValue }" @blur="onInputBlur" @focus="onInputFocus"
                    :placeholder="thePlaceholder">
        </div>
        <div class="options" @keydown.stop="doOptionsKey">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'recipientEditor',
  components: { FontAwesomeIcon },
  data() {
    return {
      inputValue: '',
      // recipients: [],
      selectedRecipient: -1
    };
  },
  props: {
    label: String,
    value: Array,
    border: Boolean,
    placeholder: {
      type: String,
      default: '$default'
    },
    parentValidation: {
      type: Boolean,
      default: false
    },
    entryValid: Boolean,
    invalidEntries: Array
  },
  watch: {
    inputValue(newVal) {
      this.$emit('entry', newVal);
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus());
  },
  methods: {
    isErrored(val) {
      if (this.invalidEntries) {
        return this.invalidEntries.indexOf(val) !== -1;
      }
      return false;
    },
    doInputKey(event) {
      if (this.inputValue) {
        if ((event.key === 'Enter') || (event.key === 'Tab') || (event.key === ',') || (event.key === ';')) {
          if (this.isValid) {
            this.saveRecipient();
          }
          event.preventDefault();
        } else if (event.key === 'Escape') {
          this.inputValue = '';
        }
      } else if (this.value.length) {
        if (event.key === 'Backspace') {
          const last = this.value[this.value.length - 1];
          this.$emit('input', this.value.slice(0, -1));
          if (!event.ctrlKey) {
            this.inputValue = last;
          }
        } else if (event.key === 'ArrowLeft') {
          this.selectedRecipient = this.value.length - 1;
          this.$refs.wrap.focus();
        } else if ((event.key === 'Home')) {
          this.selectedRecipient = 0;
          this.$refs.wrap.focus();
        }
      }
    },
    dummy() {

    },
    doRecipientKey(event) {
      console.log('rcpt key', event);
      if (event.key === 'ArrowLeft') {
        if (this.selectedRecipient > 0) {
          this.selectedRecipient--;
        }
      } else if (event.key === 'ArrowRight') {
        if (this.selectedRecipient < this.value.length - 1) {
          this.selectedRecipient++;
        } else {
          this.selectedRecipient = -1;
        }
      } else if (event.key === 'Delete') {
        this.$emit('input', [...this.value.slice(0, this.selectedRecipient),
          ...this.value.slice(this.selectedRecipient + 1)]);
        // this.recipients.splice(this.selectedRecipient, 1);
      } else if ((event.key === 'Escape') || ((event.key === 'Tab') && (!event.shiftKey))) {
        console.log('go back to input');
        this.selectedRecipient = -1;
        event.preventDefault();
      } else if ((event.key === 'Tab') && (event.shiftKey) && (this.selectedRecipient !== -1)) {
        this.selectedRecipient = -1;
      } else if (event.key === 'Home') {
        this.selectedRecipient = 0;
      } else if (event.key === 'End') {
        this.selectedRecipient = this.value.length - 1;
      } else if (event.key === 'Enter') {
        this.inputValue = this.value[this.selectedRecipient];
        this.$emit('input', [...this.value.slice(0, this.selectedRecipient),
          ...this.value.slice(this.selectedRecipient + 1)]);
        this.selectedRecipient = -1;
      } else {
        return;
      }
      if ((this.selectedRecipient >= 0) && (this.selectedRecipient < this.value.length)) {
        this.$refs.wrap.focus();
      } else {
        this.selectedRecipient = -1;
        this.$refs.input.focus();
      }
    },
    focus() {
      this.$refs.input.focus();
    },
    doOptionsKey(event) {
      console.log('opt key', event);
      if ((event.key === ' ') || (event.key === 'Enter')) {
        var click = new MouseEvent('click');
        event.target.dispatchEvent(click);
      }
    },
    saveRecipient() {
      this.$emit('input', [...this.value, this.inputValue.trim()]);
      // this.recipients.push(trim(this.inputValue));
      this.inputValue = '';
    },
    doDelete(ind) {
      this.$emit('input', [...this.value.slice(0, ind),
        ...this.value.slice(ind + 1)]);
      // this.recipients.splice(ind, 1);
      this.selectedRecipient = -1;
      this.$refs.input.focus();
    },
    onInputBlur() {
      if (this.isValid) {
        this.saveRecipient();
      }
    },
    onInputFocus() {
      this.selectedRecipient = -1;
    }
  },
  computed: {
    thePlaceholder() {
      if (this.placeholder === '$default') {
        return this.$t('recipientEditor.placeholder');
      } else {
        return this.placeholder;
      }
    },
    isValid() {
      let trimmed = this.inputValue.trim();
      if (this.parentValidation) {
        return this.entryValid;
      }
      // Simple email address
      const re1 = /^[^\s@]+@[a-z0-9.-]+\.[a-z0-9-]{2,50}$/i;
      if (re1.exec(trimmed)) {
        console.log('simple match');
        return true;
      }
      // Simple email address in <>
      const re2 = /^<[^\s@]+@[a-z0-9.-]+\.[a-z0-9-]{2,50}>$/i;
      if (re2.exec(trimmed)) {
        console.log('angle match');
        return true;
      }

      // replace qtext with 'a' so it'll pass the subsequent test
      trimmed = trimmed.replace(/"([^"\\]|\\.)*"/gi, 'a');

      console.log('validator', trimmed);
      const re3 = /^[a-z0-9!#$%&'*+=?^_`{}|~ -]+<[^\s@]+@[a-z0-9.-]+\.[a-z0-9-]{2,50}>$/i;
      if (re3.exec(trimmed)) {
        console.log('nameaddr match');
        return true;
      }

      return false;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .recipientWrap {
        display: grid;
        grid-template-columns: auto 1fr auto;
        grid-template-areas: "label entries options";
        width: 100%;
        overflow: hidden;
        outline: none;

        &.border {
            padding: 5px;
            border: $input-border-width solid $input-border-color;
            border-radius: $input-border-radius;
            &:focus-within {
                box-shadow: $input-focus-box-shadow;
            }
        }

        label {
            font-weight: bold;
            margin:  0 10px;
            grid-area: label;
            display: inline-block;
            border-radius: 3px;
            min-width: 5em;
        }
        &:focus:not(.tagActive) label {
            background-color: $recipient-label-selected;
        }

        .options {
            grid-area: options;
            color: $gray-600;
            span {
                margin-right: 10px;
            }
        }

        .entries {
            grid-area: entries;
            display: flex;
            flex-wrap: wrap;

            .tag {
                background-color: $recipient-tag;
                margin: 1px 5px 0 0;
                border-radius: 10px;
                padding: 0 8px 3px 8px;
                white-space: nowrap;
                &.selected {
                    background-color: $recipient-tag-selected;
                    outline: none;
                }
                &.errored {
                    background-color: scale_color($danger, $lightness: 60%);
                }
                .deleter {
                    height: 1.3em;
                    cursor: pointer;
                    vertical-align: middle;
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.3);
                        color: $light;
                    }
                }
            }
            .input {
                font-size: 1em;
                margin: 0;
                padding: 0 3px;
                border-radius: 10px;
                border: none;
                flex-grow: 1;
                text-decoration: $validation_fail_decoration;
                outline: none;
                &.valid, &.empty {
                    text-decoration: none;
                }
                &.valid {
                    background-color: $validation_ok;
                }
            }
        }
    }

</style>
